/* global opslaan, annuleren, noConnection, csrf_token */

$(document).on('click', '#ik_wil_claimant_inzien', function () {
  location.href =
    'index.php?view=herstelregisseur.dossier&script_action=toon_claimant&csrf_token=' +
    csrf_token;
});

$(document).on(
  'click',
  '#ik_wil_dekking_aansprakelijkheid_inzien',
  function () {
    location.href =
      'index.php?view=behandelaar.dossier&script_action=dekking_aansprakelijkheid_inzien&csrf_token=' +
      csrf_token;
  }
);

$(document).on('click', '#third_parties', function () {
  location.href =
    'index.php?view=behandelaar.thirdparties&script_action=third_parties&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_email_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=email_editor&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_dossier_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=dossier_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_dossier_inzien_herstel', function () {
  location.href =
    'index.php?view=herstelregisseur.dossier&script_action=dossier_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_dossier_inzien_expert', function () {
  location.href =
    'index.php?view=expert.dossier&script_action=dossier_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_dossier_inzien_makelaar', function () {
  location.href =
    'index.php?view=makelaar.dossier&script_action=dossier_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_friss_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=friss_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#check_list', function () {
  location.href =
    'index.php?view=behandelaar.checklist&script_action=check_list&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#submit_schade_wijzigen', function () {
  const formulier = $(this).closest('form').attr('id');
  const parameters = $('#' + formulier).serialize();
  const vraaggroep_actief = $('#' + formulier)
    .find('input[name="vraaggroep_actief"]')
    .val();
  $.post('views/behandelaar.dossier.php', parameters, function () {
    window.open('/index.php?view=consument.dialoog#' + vraaggroep_actief);
  }).fail(function (jqXHR, textStatus, errorThrown) {
    noConnection(textStatus, errorThrown);
  });
});

$(document).on('click', '#ik_wil_ses_resultaat_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=ses_resultaat_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_ses_resultaat_inzien_expert', function () {
  location.href =
    'index.php?view=expert.dossier&script_action=ses_resultaat_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_ems_resultaat_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=ems_resultaat_inzien&csrf_token=' +
    csrf_token;
});
$(document).on('click', '#ik_wil_ems_resultaat_inzien_expert', function () {
  location.href =
    'index.php?view=expert.dossier&script_action=ems_resultaat_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_ems_resultaat_inzien_herstel', function () {
  location.href =
    'index.php?view=herstelregisseur.dossier&script_action=ems_resultaat_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_score_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=score_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_autofilter_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=autofilter_inzien&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_audit_trail_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=toon_audit_trail&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_polisvoorwaarden_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=toon_polis&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_polisvoorwaarden_inzien_herstel', function () {
  location.href =
    'index.php?view=herstelregisseur.dossier&script_action=toon_polis&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_personalia_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=toon_verzekerde&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_personalia_inzien_herstel', function () {
  location.href =
    'index.php?view=herstelregisseur.dossier&script_action=toon_verzekerde&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_personalia_inzien_expert', function () {
  location.href =
    'index.php?view=expert.dossier&script_action=toon_verzekerde&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_personalia_inzien_makelaar', function () {
  location.href =
    'index.php?view=makelaar.dossier&script_action=toon_verzekerde&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_reservations_inzien', function () {
  location.href =
    'index.php?view=behandelaar.dossier&script_action=reservations&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_chatlog_inzien', function () {
  location.href =
    'index.php?view=behandelaar.chatlog&script_action=toon_chatlog&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_gedragsanalyse_inzien_herstel', function () {
  location.href =
    'index.php?view=herstelregisseur.gedragsanalyse&script_action=toon_gedragsanalyse&csrf_token=' +
    csrf_token;
});

$(document).on('click', '#ik_wil_naar_hersteller_mutatie', function () {
  const parameters = '&script_action=mutaties_tonen&csrf_token=' + csrf_token;
  location.href = 'index.php?view=behandelaar.hersteller_mutatie' + parameters;
});

$(document).on('click', '#ik_wil_statusinformatie_inzien', function () {
  const parameters =
    'script_action=toon_vrije_tekst_status&csrf_token=' + csrf_token;
  $.post('views/behandelaar.dossier.php', parameters, function (output) {
    $('#dialog').html(output).prepend('<div id="meldingen"></div>');
    $('#dialog').dialog({
      title: opslaan,
      resizable: false,
      height: 450,
      width: 490,
      modal: true,
      open: function () {
        $(this).find(':button').hide();
      },
      buttons: [
        {
          text: opslaan,
          click: function () {
            const status_schadegeval = $('#status_schadegeval').val();
            let parameters = 'status_schadegeval=' + status_schadegeval;
            if ($('#status_claim').length) {
              const status_claim = $('#status_claim').val();
              parameters = parameters + '&status_claim=' + status_claim;
            }
            parameters =
              parameters +
              '&script_action=wijzig_vrije_tekst_status&csrf_token=' +
              csrf_token;
            $.post(
              'views/behandelaar.dossier.php',
              parameters,
              function (output) {
                if (output.search('ERROR') != -1) {
                  $('#dialog>#meldingen')
                    .show(100)
                    .html('<h3>' + output + '</h3>');
                } else {
                  $('#dialog').dialog('close');
                }
              }
            ).fail(function (jqXHR, textStatus, errorThrown) {
              noConnection(textStatus, errorThrown);
            });
          },
        },
        {
          text: annuleren,
          click: function () {
            $(this).dialog('close');
          },
        },
      ],
    });
    $('#dialog').dialog('open');
  }).fail(function (jqXHR, textStatus, errorThrown) {
    noConnection(textStatus, errorThrown);
  });
});

$(document).on('click', '#ik_wil_statusinformatie_inzien_herstel', function () {
  StatusinformatieTonen();
});

$(document).on('click', '#ik_wil_bonus_malus_impact_inzien', function () {
  ImpactBonusMalusTonen();
});

$(document).on('click', '#ik_wil_aansprakelijkheid_inzien', function () {
  AansprakelijkheidTonen();
});

$(document).on('click', '#ik_wil_dekking_inzien', function () {
  DekkingTonen();
});

$(document).on('click', '#ik_wil_dekking_inzien_herstel', function () {
  const parameters = 'script_action=toon_dekking&csrf_token=' + csrf_token;
  $.post('views/herstelregisseur.dossier.php', parameters, function (output) {
    $('#dialog').html(output).prepend('<div id="meldingen"></div>');
    $('#dialog').dialog({
      title: opslaan,
      resizable: false,
      height: 450,
      width: 490,
      modal: true,
      open: function () {
        $(this).find(':button').hide();
      },
      buttons: [
        {
          text: annuleren,
          click: function () {
            $(this).dialog('close');
          },
        },
      ],
    });
    $('#dialog').dialog('open');
  }).fail(function (jqXHR, textStatus, errorThrown) {
    noConnection(textStatus, errorThrown);
  });
});

$(function () {
  $('#toonActie').change(function () {
    const selectVal = $(this).val();

    if (selectVal == '') return;

    switch (selectVal) {
      case 'ik_wil_statusinformatie_inzien':
        StatusinformatieTonen();
        break;
      case 'ik_wil_dekking_inzien':
        DekkingTonen();
        break;
      case 'export_report':
        RapportenTonen();
        break;
      case 'ik_wil_bonus_malus_impact_inzien':
        ImpactBonusMalusTonen();
        break;
      case 'ik_wil_aansprakelijkheid_inzien':
        AansprakelijkheidTonen();
        break;

      case 'sms':
        SmsTonen();
        break;

      default:
        break;
    }

    $(this).val('');
  });
});

function AansprakelijkheidTonen() {
  let parameters =
    'script_action=toon_aansprakelijkheid&csrf_token=' + csrf_token;
  $.post('views/behandelaar.dossier.php', parameters, function (output) {
    $('#dialog').html(output).prepend('<div id="meldingen"></div>');
    $('#dialog').dialog({
      title: opslaan,
      resizable: false,
      height: 500,
      width: 830,
      modal: true,
      open: function () {
        $(this).find(':button').hide();
      },
      buttons: [
        {
          text: opslaan,
          click: function () {
            const aansprakelijkheid_verzekerde = $(
              '#aansprakelijkheid_verzekerde'
            ).val();
            const aansprakelijkheid_tegenpartij = $(
              '#aansprakelijkheid_tegenpartij'
            ).val();
            parameters =
              '&aansprakelijkheid_verzekerde=' +
              aansprakelijkheid_verzekerde +
              '&aansprakelijkheid_tegenpartij=' +
              aansprakelijkheid_tegenpartij +
              '&script_action=wijzig_aansprakelijkheid&csrf_token=' +
              csrf_token;
            $.post(
              'views/behandelaar.dossier.php',
              parameters,
              function (output) {
                if (output.search('ERROR') != -1) {
                  $('#dialog>#meldingen')
                    .show(100)
                    .html('<h3>' + output + '</h3>');
                } else {
                  $('#dialog').dialog('close');
                }
              }
            ).fail(function (_jqXHR, textStatus, errorThrown) {
              noConnection(textStatus, errorThrown);
            });
          },
        },
        {
          text: annuleren,
          click: function () {
            $(this).dialog('close');
          },
        },
      ],
    });
    $('#dialog').dialog('open');
  }).fail(function (_jqXHR, textStatus, errorThrown) {
    noConnection(textStatus, errorThrown);
  });
}

function ImpactBonusMalusTonen() {
  let parameters =
    'script_action=toon_bonus_malus_impact&csrf_token=' + csrf_token;
  $.post('views/behandelaar.dossier.php', parameters, function (output) {
    $('#dialog').html(output).prepend('<div id="meldingen"></div>');
    $('#dialog').dialog({
      title: opslaan,
      resizable: false,
      height: 250,
      width: 490,
      modal: true,
      open: function () {
        $(this).find(':button').hide();
      },
      buttons: [
        {
          text: opslaan,
          click: function () {
            parameters = $(
              '#formulier_wijzig_bonus_malus_impact-1'
            ).serialize();
            $.post(
              'views/behandelaar.dossier.php',
              parameters,
              function (output) {
                if (output.search('ERROR') != -1) {
                  $('#dialog>#meldingen')
                    .show(100)
                    .html('<h3>' + output + '</h3>');
                } else {
                  $('#dialog').dialog('close');
                }
              }
            ).fail(function (_jqXHR, textStatus, errorThrown) {
              noConnection(textStatus, errorThrown);
            });
          },
        },
        {
          text: annuleren,
          click: function () {
            $(this).dialog('close');
          },
        },
      ],
    });
    $('#dialog').dialog('open');
  }).fail(function (_jqXHR, textStatus, errorThrown) {
    noConnection(textStatus, errorThrown);
  });
}

function RapportenTonen() {
  const parameters = {
    script_action: 'dialoog_export_dossier',
    csrf_token: csrf_token,
  };

  // Get export options using AJAX
  $.post('views/behandelaar.dossier.php', parameters, function (output) {
    const buttons = [
      {
        text: 'Sluiten',
        click: function () {
          $(this).dialog('close');
        },
      },
    ];

    $('#dialog')
      .html(output)
      .dialog({
        open: function (_event, _ui) {
          $(this)
            .find('a')
            .on('click', function () {
              $('#dialog').dialog('close');
            });
        },
        title: 'Rapportage',
        resizable: false,
        height: 400,
        width: 360,
        modal: true,
        buttons: buttons,
      });
  }).fail(function (_jqXHR, textStatus, errorThrown) {
    noConnection(textStatus, errorThrown);
  });
}

function DekkingTonen() {
  const parameters = 'script_action=toon_dekking&csrf_token=' + csrf_token;
  $.post('views/behandelaar.dossier.php', parameters, function (output) {
    $('#dialog').html(output).prepend('<div id="meldingen"></div>');
    $('#dialog').dialog({
      title: opslaan,
      resizable: false,
      height: 450,
      width: 490,
      modal: true,
      open: function () {
        $(this).find(':button').hide();
      },
      buttons: [
        {
          text: annuleren,
          click: function () {
            $(this).dialog('close');
          },
        },
      ],
    });
    $('#dialog').dialog('open');
  }).fail(function (_jqXHR, textStatus, errorThrown) {
    noConnection(textStatus, errorThrown);
  });
}

function StatusinformatieTonen() {
  const parameters =
    'script_action=toon_vrije_tekst_status&csrf_token=' + csrf_token;
  $.post('views/behandelaar.dossier.php', parameters, function (output) {
    $('#dialog').html(output).prepend('<div id="meldingen"></div>');
    $('#dialog').dialog({
      title: opslaan,
      resizable: false,
      height: 450,
      width: 490,
      modal: true,
      open: function () {
        $(this).find(':button').hide();
      },
      buttons: [
        {
          text: opslaan,
          click: function () {
            const status_schadegeval = $('#status_schadegeval').val();
            let parameters = 'status_schadegeval=' + status_schadegeval;
            if ($('#status_claim').length) {
              const status_claim = $('#status_claim').val();
              parameters = parameters + '&status_claim=' + status_claim;
            }
            parameters =
              parameters +
              '&script_action=wijzig_vrije_tekst_status&csrf_token=' +
              csrf_token;
            $.post(
              'views/behandelaar.dossier.php',
              parameters,
              function (output) {
                if (output.search('ERROR') != -1) {
                  $('#dialog>#meldingen')
                    .show(100)
                    .html('<h3>' + output + '</h3>');
                } else {
                  $('#dialog').dialog('close');
                }
              }
            ).fail(function (_jqXHR, textStatus, errorThrown) {
              noConnection(textStatus, errorThrown);
            });
          },
        },
        {
          text: annuleren,
          click: function () {
            $(this).dialog('close');
          },
        },
      ],
    });
    $('#dialog').dialog('open');
  }).fail(function (_jqXHR, textStatus, errorThrown) {
    noConnection(textStatus, errorThrown);
  });
}

function SmsTonen() {
  const parameters =
    '&script_action=notificaties_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.notificatie' + parameters;
}
